"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type ComponentType, type ReactNode } from "react";
import { usePathname } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WebLayout from "@/components/layout/WebLayout";
import MobileLayout from "@/components/layout/MobileLayout";
import SmallScreenLayout from "@/components/layout/SmallScreenLayout";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { SIDEBAR_MOBILE_BREAKPOINT } from "@/constants/sidebar";
import FooterWrapper from "@/FooterWrapper";
export default function LayoutWrapper(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const {
    isApp,
    hasTouchScreen
  } = useDeviceInfo();
  const isSmallScreen = useIsMobileScreen();
  const [isTouchTabletViewport, setIsTouchTabletViewport] = useState(_temp);
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== hasTouchScreen) {
    t1 = () => {
      if (!hasTouchScreen) {
        setIsTouchTabletViewport(false);
        return;
      }
      const browserWindow = globalThis.window;
      if (browserWindow === undefined) {
        setIsTouchTabletViewport(false);
        return;
      }
      const mediaQuery = browserWindow.matchMedia(`(max-width: ${SIDEBAR_MOBILE_BREAKPOINT - 0.02}px)`);
      setIsTouchTabletViewport(mediaQuery.matches);
      const listener = event => {
        setIsTouchTabletViewport(event.matches);
      };
      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", listener);
        return () => {
          mediaQuery.removeEventListener?.("change", listener);
        };
      }
      const previousOnChange = mediaQuery.onchange;
      mediaQuery.onchange = listener;
      return () => {
        if (mediaQuery.onchange === listener) {
          mediaQuery.onchange = previousOnChange ?? null;
        }
      };
    };
    t2 = [hasTouchScreen];
    $[0] = hasTouchScreen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const isAccessOrRestricted = pathname?.startsWith("/access") || pathname?.startsWith("/restricted");
  let LayoutComponent = WebLayout;
  const isSmallLayout = hasTouchScreen && (isSmallScreen || isTouchTabletViewport);
  if (isApp) {
    LayoutComponent = MobileLayout;
  } else {
    if (isSmallLayout) {
      LayoutComponent = SmallScreenLayout;
    }
  }
  if (isAccessOrRestricted) {
    let t3;
    if ($[3] !== children) {
      t3 = <>{children}</>;
      $[3] = children;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FooterWrapper />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <>{children}{t3}</>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== LayoutComponent || $[9] !== t4) {
    t5 = <LayoutComponent>{t4}</LayoutComponent>;
    $[8] = LayoutComponent;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp() {
  if (globalThis.window === undefined) {
    return false;
  }
  return globalThis.window.innerWidth < SIDEBAR_MOBILE_BREAKPOINT;
}